import {
  readForm,
  editForm,
  createForm,
  deleteForm,
} from "~/shared/formAbilities"

export const useFormPermissions = async () => {
  const canReadForm = await allows(readForm)
  const canEditForm = await allows(editForm)
  const canCreateForm = await allows(createForm)
  const canDeleteForm = await allows(deleteForm)

  return { canReadForm, canEditForm, canCreateForm, canDeleteForm }
}
